import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/custom-theme-button';
import * as Styled from './styled';
var Footer = /*#__PURE__*/function (_React$Component) {
  _inherits(Footer, _React$Component);
  var _super = _createSuper(Footer);
  function Footer() {
    _classCallCheck(this, Footer);
    return _super.apply(this, arguments);
  }
  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        currentScreenIdx = _this$props.currentScreenIdx,
        numScreens = _this$props.numScreens,
        onCancel = _this$props.onCancel,
        onNext = _this$props.onNext,
        onPrevious = _this$props.onPrevious,
        secondaryActions = _this$props.secondaryActions,
        submitButton = _this$props.submitButton;
      return /*#__PURE__*/React.createElement(Styled.FooterOuter, null, /*#__PURE__*/React.createElement("div", null, secondaryActions), /*#__PURE__*/React.createElement(ButtonGroup, null, currentScreenIdx < 1 ? /*#__PURE__*/React.createElement(Button, {
        onClick: onCancel
      }, "Cancel") : /*#__PURE__*/React.createElement(Button, {
        onClick: onPrevious
      }, "Previous"), currentScreenIdx < numScreens - 1 ? /*#__PURE__*/React.createElement(Button, {
        appearance: "primary",
        onClick: onNext
      }, "Next") : submitButton));
    }
  }]);
  return Footer;
}(React.Component);
export { Footer as default };